import LineChart from "./LineChart.vue";
import BarChart from "./BarChart.vue";
import DateTimeChart from "./text/Datetime.vue";
import PieChart from "./PieChart.vue";
import PointChart from "./PointChart.vue";
import MapChart from "./map/MapChart.vue";
import RadarChart from "./RadarChart.vue";
import Title from "./text/Title.vue";
import Button from "./text/button.vue";
import Weather from "./text/Weather.vue";
import ImageChart from "./images/image/index.vue";
import ViedoHlsChart from "./images/VideoHls.vue";
import ManyVideoHls from "./images/ManyVideoHls.vue";
import VideoList from "./video/VideoList.vue";

import PersonImages from './images/personImages.vue'
import CarouselChart from './images/Carousel.vue'
import HotMapChart from './map/HotMapChart.vue'
import MoveMapChart from './map/MoveMapChart.vue'
import CustomMapChart from './map/CustomMapChart.vue'
import CustomMapChart3 from './map/CustomMapChart3.vue'
import DeviderH from './text/DeviderH.vue'
import DeviderV from './text/DeviderV.vue'
import NumberChart from './text/Number.vue'
import Box from './Box.vue'
import CustomBox from './box/customBox.vue'
import Tabs from './Tabs.vue'

import CustomCard from './CustomCard/index.vue'
import CustomCard2 from './CustomCard/index2.vue'

import FwFormCard from './basic/FwFormCard.vue'

import CustomProcess from './process/CustomProcess.vue'

import BasicRelationChart from './relation/BasicRelationChart.vue'

import Bar3dChart from './3d/Bar3dChart.vue'
import Line3dChart from './3d/Line3dChart.vue'
import WordCloudChart from './atlas/WordCloudChart.vue'
import GraphChart from './graph/GraphChart.vue'
import CustomTable from './table/CustomTable.vue'
import CustomUrlTable from './table/CustomUrlTable.vue'
import TimeLineChart from './process/timeline.vue'
import CustomViewForm from './form/customViewForm.vue'

import FwBadage from './basic/FwBadge.vue'

import FwPageBack from './basic/FwPageBack.vue'
import FwBasicTab from './basic/FwTab.vue'
import FwBasicButton from './basic/FwButton.vue'
import FwSaveButton from './basic/FwSaveButton.vue'
import FwBaseDialog from './basic/FwBaseDialog.vue'
import FwBaseAreaLink from './basic/FwAreaLink.vue'
import FwMoveMapLocation from './basic/FwMoveMapLocation.vue'
// import BaidumapChart from './BaiduMapChart.vue'
const customChart = {
  LineChart,
  BarChart,
  PieChart,
  MapChart,
  RadarChart,
  Title,
  Button,
  Box,
  PointChart,
  DateTimeChart,
  ImageChart,
  ViedoHlsChart,
  ManyVideoHls,
  CarouselChart,
  HotMapChart,
  Weather,
  MoveMapChart,
  DeviderH,
  DeviderV,
  NumberChart,
  Bar3dChart,
  BasicRelationChart,
  WordCloudChart,
  Line3dChart,
  GraphChart,
  CustomBox,
  CustomCard,
  CustomCard2,
  CustomTable,
  CustomUrlTable,
  CustomMapChart,
  CustomMapChart3,
  TimeLineChart,
  CustomViewForm,
  PersonImages,
  VideoList,
  CustomProcess,
  FwBadage,
  FwPageBack,
  FwBasicTab,
  FwFormCard,
  FwBasicButton,
  FwSaveButton,
  FwBaseDialog,
  FwBaseAreaLink,
  FwMoveMapLocation
  
  
};

const install = function(Vue, opts = {}) {
  Vue.component("FwLineChart", LineChart);
  Vue.component("FwBarChart", BarChart);
  Vue.component("FwPieChart", PieChart);
  Vue.component("FwMapChart", MapChart);
  Vue.component("FwRadarChart", RadarChart);
  Vue.component("FwPointChart", PointChart);
  Vue.component("FwTitle", Title);
  Vue.component("FwButton", Button);
  Vue.component("FwWeather", Weather);
  Vue.component("FwDatetime", DateTimeChart);
  Vue.component("FwBox", Box);
  Vue.component("FwCustomBox", CustomBox);
  Vue.component("FwImage", ImageChart);
  Vue.component("FwVideoHls", ViedoHlsChart);
  Vue.component("FwManyVideoHls", ManyVideoHls);
  Vue.component("FwCarouselChart", CarouselChart)
  Vue.component("FwHotMap", HotMapChart)
  Vue.component("FwMoveMap", MoveMapChart)
  Vue.component("FwDeviderH", DeviderH)
  Vue.component("FwDeviderV", DeviderV)
  Vue.component("FwNumberChart", NumberChart)
  Vue.component("FwThreeBarChart", Bar3dChart)
  Vue.component("FwThreeLineChart", Line3dChart)
  Vue.component("FwVideoList",VideoList)
  Vue.component("FwRelationChart", BasicRelationChart)
  Vue.component("FwWordCloudChart", WordCloudChart)
  Vue.component("FwTabs", Tabs)
  Vue.component("FwGraphChart", GraphChart)
  Vue.component("FwCard",CustomCard)
  Vue.component("FwCard2",CustomCard2)
  Vue.component("FwCustomTable",CustomTable)
  Vue.component("FwCustomUrlTable",CustomUrlTable)

  Vue.component("FwCustomMapChart",CustomMapChart)
  Vue.component("FwCustomMapChart3",CustomMapChart3)
  Vue.component("FwTimeLineChart",TimeLineChart)
  Vue.component("FwCustomViewForm",CustomViewForm)
  Vue.component("FwPersonImages",PersonImages)
  Vue.component("FwCustomProcess",CustomProcess)
  Vue.component("FwBadage",FwBadage)
  Vue.component("FwPageBack",FwPageBack)
  Vue.component("FwBasicTab",FwBasicTab)
  Vue.component("FwFormCard",FwFormCard)
  Vue.component("FwBasicButton",FwBasicButton)
  Vue.component("FwSaveButton",FwSaveButton)
  Vue.component("FwBaseDialog",FwBaseDialog)
  Vue.component("FwBaseAreaLink",FwBaseAreaLink)
  Vue.component("FwMoveMapLocation",FwMoveMapLocation)
  
  // Vue.component("FwBaidumapChart", BaidumapChart);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default Object.assign(customChart, {
  install
});



// WEBPACK FOOTER //
// ./src/components/index.js